<template>
  <div class="wrapper">
    <div v-if="loading" class="loading-state">
      <div class="d-flex justify-content-center align-items-center min-vh-100">
        <div class="text-center w-5 h-5">
          <span class="spinner-border"></span>
        </div>
      </div>
    </div>
    <div v-else>
      <section class="online-course-details course-details-page section-space">
        <!-- <skeleton-loader id="courseDetailLoader" :count="12" :showEmptyTemplate="true" :defaultLoadingProp="true">
        <template v-slot:default="{}"> -->
        <!-- <p class="course-heading-caption" v-if="routeParams.board">
              {{ routeParams.board.replace("-", " ") }} -
              {{ routeParams.group }}
            </p> -->
        <!-- <page-header :caption="courseDetail && courseDetail.CourseGroupName"
        :heading="courseDetail && courseDetail.DisplayName" :desc="courseDetail && courseDetail.ShortDescription" /> -->
        <section class="program-details-top">
          <div class="container">


            <div class="row top-row">
              <div class="col-md-6 order-2 order-md-1">
                <div class="course-heading" v-if="courseDetail && courseDetail.DisplayName">{{ courseDetail.DisplayName
                }}</div>
                <div class="course-shortdesc" v-if="courseDetail && courseDetail.ShortDescription">{{
                  courseDetail.ShortDescription }}</div>
                <div class="details-info" v-if="courseDetail && courseDetail.Description">
                  <div v-html="courseDetail && courseDetail.Description"></div>
                </div>
                <div v-if="courseDetail && courseDetail.Packages.length" class="features-wrap">
                  <h4>Course Features</h4>
                  <div v-for="(detail, index) in courseDetail.Packages[0].Features" :key="detail.index"
                    class="col-12 feature-col p-0">
                    <div class="feature-name-details">
                      <p>
                        <strong>{{ detail.Name }} :</strong>{{ detail.Description }}
                      </p>
                    </div>

                    <div class="feature-details">
                      <!-- <div class="features-heading-wrap">
                      <h5 class="">&nbsp;</h5>
                    </div> -->
                      <div class="plan-features-wrap text-center d-none">
                        <div v-for="packages in courseDetail.Packages" :key="packages.SOSPaymentPackageId"
                          class="plan-feature-name">
                          <div
                            v-if="packages.Features && packages.Features[index] && packages.Features[index].IsFeatureAllowed">
                            <img src="/assets/images/checked.svg" width="24" height="24" alt="" />
                          </div>
                          <div v-else class="not-available">
                            <img src="/assets/images/checked.svg" width="24" height="24" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 detail-card-main-div order-1 order-md-2">
                <!-- {{ courseDetail.VideoLink }} -->
                <div class="detail-card-div p-0">
                  <div class="course-img" v-if="courseDetail && courseDetail.CourseImage" @click="showVideoPopup">
                    <svg v-if="courseDetail.VideoLink" width="74" height="74" viewBox="0 0 74 74" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="37" cy="37" r="37" fill="#C5C7FC" fill-opacity="0.44" />
                      <circle cx="36.9987" cy="37.0001" r="24.3658" fill="" />
                      <path d="M47.793 36.6144L31.6055 44.9589L31.6055 28.2699L47.793 36.6144Z" fill="white" />
                    </svg>

                    <img :src="courseDetail.CourseImage" width="614" height="361" :alt="courseDetail.DisplayName" />
                  </div>

                  <div class="course-img" v-else>
                    <i class="no-course-image fal fa-user-graduate"></i>
                  </div>

                  <div class="program-top-left">
                    <div class="program-head">
                      <!-- <span v-if="courseDetail.CourseGroupName" class="header-caption">{{
                        courseDetail.CourseGroupName
                      }}</span> -->
                      <!-- <h2 class="heading">{{ courseDetail.DisplayName }}</h2>
                      <span class="desc d-block">{{
                        courseDetail.ShortDescription
                      }}</span> -->
                    </div>
                    <div class="">
                      <div class="">
                        <div v-if="courseDetail" class="white-box sticky-side-box" id="bar-fixed">
                          <!-- <div class="sticky-img-cntr" v-if="courseDetail && courseDetail.CourseImage">
                        <img :src="courseDetail.CourseImage" width="100%" height="100%"
                          :alt="courseDetail.DisplayName" />
                      </div>
                      <div class="sticky-img-cntr" v-else>
                        <i class="no-course-image fal fa-user-graduate"></i>
                      </div> -->
                          <!-- <div class="cardContainer" ref="stickyBox"> -->
                          <!-- <div class="sticky-side-box-margin"> -->

                          <!-- <div class="cart-btns p-0" v-if="courseDetail && courseDetail.IsFree">
                      <button @click="FreeCourse(courseDetail)" class="btn secondary-btn">Enroll</button>
                    </div> -->
                          <!-- <div class="cart-btns p-0"
                            v-if="courseDetail && courseDetail.Packages && courseDetail.Packages.length > 1">
                            <div class="btnHolder">
                              <button @click="scrollToPaymentPlans()" class="btn secondary-btn choose-plan">Choose
                                Plan</button>
                            </div>
                          </div> -->
                          <!-- <div class="cart-btns p-0"
                      v-if="courseDetail && courseDetail.Packages && !courseDetail.Packages.length && !courseDetail.IsFree">
                      <div class="btnHolder">
                        <button class="btn secondary-btn">Coming Soon</button>
                      </div>
                    </div> -->

                          <!-- <div v-if="courseDetail && courseDetail.Summary != undefined && !courseDetail.IsFree" class="course-includes">
                            <div class="title">This Course Includes:</div>
                            <div class="row">
                              <div class="col-sm-6" :class="courseDetail.Summary.VideoCount == 0 ? 'noDataAvail' : ''">
                                <div class="subtitle">
                                  <i class="fal fa-play-circle"></i>
                                  {{ courseDetail.Summary.VideoCount != 0 ? courseDetail.Summary.VideoCount : "" }}
                                  Videos
                                </div>
                              </div>
                              <div class="col-sm-6" :class="courseDetail.Summary.ReadingCount == 0 ? 'noDataAvail' : ''">
                                <div class="subtitle">
                                  <i class="fal fa-book-open"></i>
                                  {{ courseDetail.Summary.ReadingCount != 0 ? courseDetail.Summary.ReadingCount : "" }}
                                  Readings
                                </div>
                              </div>
                              <div class="col-sm-6" :class="courseDetail.Summary.TestCount == 0 ? 'noDataAvail' : ''">
                                <div class="subtitle">
                                  <i class="fal fa-file-signature"></i>
                                  {{ courseDetail.Summary.TestCount != 0 ? courseDetail.Summary.TestCount : "" }}
                                  Quizzes
                                </div>
                              </div>
                              <div class="col-sm-6" :class="courseDetail.Summary.AssignmentCount == 0 ? 'noDataAvail' : ''">
                                <div class="subtitle">
                                  <i class="fal fa-copy"></i>
                                  {{ courseDetail.Summary.AssignmentCount != 0 ? courseDetail.Summary.AssignmentCount : "" }} Assignments
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <!-- </div> -->
                          <!-- Single Cart -->
                          <div v-if="courseDetail && courseDetail.Packages.length > 0">
                            <singlePaymentPlan @choosePlan="showPaymentPlansPopup" @trial="AddToTrial(true)"
                              @scrollFeature="scrolltoFeature" />
                          </div>
                          <div
                            v-else-if="courseDetail && courseDetail.Packages && !courseDetail.Packages.length && !courseDetail.IsFree">
                            <div class="title mt-2 coming-soon-color">Coming Soon</div>
                            <!-- <div
                              v-if="courseDetail && courseDetail.Summary != undefined && (!courseDetail.IsFree || !courseDetail.IsSpecialActivity)"
                              class="course-includes">
                              <div class="title">This Course Includes:</div>
                              <div class="">
                                <div class="subtitle-div">
                                  <div class="single-title">
                                    <div class="subtitle"
                                      :class="courseDetail.Summary.VideoCount == 0 ? 'noDataAvail' : ''">
                                      <svg width="26" height="27" viewBox="0 0 26 27" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M13.0047 1.98859C10.6907 1.98859 8.42858 2.67478 6.50452 3.96039C4.58047 5.246 3.08085 7.07329 2.1953 9.21119C1.30976 11.3491 1.07806 13.7016 1.5295 15.9711C1.98095 18.2407 3.09527 20.3255 4.73154 21.9617C6.36782 23.598 8.45256 24.7123 10.7221 25.1638C12.9917 25.6152 15.3442 25.3835 17.4821 24.498C19.62 23.6124 21.4473 22.1128 22.7329 20.1888C24.0185 18.2647 24.7047 16.0026 24.7047 13.6886C24.7047 10.5856 23.472 7.60961 21.2778 5.41544C19.0837 3.22126 16.1077 1.98859 13.0047 1.98859ZM13.0047 23.7168C11.0213 23.7168 9.08245 23.1286 7.43332 22.0267C5.78419 20.9248 4.49885 19.3586 3.73984 17.5262C2.98083 15.6938 2.78224 13.6775 3.16918 11.7322C3.55612 9.7869 4.51122 8.00005 5.91368 6.59758C7.31615 5.19511 9.10301 4.24002 11.0483 3.85308C12.9936 3.46614 15.0099 3.66473 16.8423 4.42374C18.6747 5.18275 20.2409 6.46809 21.3428 8.11722C22.4447 9.76635 23.0329 11.7052 23.0329 13.6886C23.0329 16.3482 21.9764 18.8989 20.0957 20.7796C18.215 22.6602 15.6643 23.7168 13.0047 23.7168Z"
                                          fill="#111111" stroke="white" stroke-width="0.325" />
                                        <path
                                          d="M17.9308 13.3154C17.8497 13.1527 17.7178 13.0207 17.5551 12.9397L10.8691 9.59741C10.7417 9.53386 10.6002 9.50391 10.458 9.51039C10.3158 9.51687 10.1776 9.55957 10.0565 9.63445C9.93537 9.70932 9.8354 9.81388 9.76604 9.93822C9.69669 10.0626 9.66024 10.2025 9.66016 10.3449V17.0308C9.66024 17.1732 9.69669 17.3132 9.76604 17.4375C9.8354 17.5619 9.93537 17.6664 10.0565 17.7413C10.1776 17.8161 10.3158 17.8589 10.458 17.8653C10.6002 17.8718 10.7417 17.8419 10.8691 17.7783L17.5551 14.436C17.7534 14.3372 17.9045 14.1636 17.9749 13.9535C18.0454 13.7434 18.0295 13.5138 17.9308 13.3154ZM11.332 15.6788V11.6969L15.3139 13.6872L11.332 15.6788Z"
                                          fill="#111111" stroke="white" stroke-width="0.325" />
                                      </svg>
                                      Videos
                                    </div>
                                  </div>
                                  <div class="single-title"
                                    :class="courseDetail.Summary.ReadingCount == 0 ? 'noDataAvail' : ''">
                                    <div class="subtitle">
                                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M25.4729 5.46763H23.7654V4.88122C23.7699 4.76817 23.7366 4.65686 23.6708 4.56505C23.605 4.47323 23.5104 4.40619 23.4023 4.3746C22.2172 4.06287 20.9968 3.90663 19.7718 3.90978C18.5293 3.85817 17.2891 4.05557 16.1234 4.49048C14.9577 4.92539 13.8899 5.58909 12.9823 6.44286C12.0779 5.58446 11.0107 4.91778 9.84423 4.48258C8.67776 4.04738 7.43598 3.85257 6.19294 3.90978C4.96786 3.90663 3.74754 4.06287 2.56242 4.3746C2.45426 4.40619 2.35973 4.47323 2.29391 4.56505C2.22809 4.65686 2.19476 4.76817 2.19924 4.88122V5.46256H0.504414C0.370635 5.46256 0.242336 5.51593 0.14774 5.61094C0.053144 5.70595 5.49032e-07 5.83481 5.49032e-07 5.96918V22.1252C-0.000130165 22.2142 0.0230817 22.3016 0.0672999 22.3787C0.111518 22.4559 0.175182 22.5199 0.251885 22.5645C0.328587 22.609 0.415622 22.6325 0.504228 22.6325C0.592834 22.6326 0.679886 22.6091 0.756621 22.5647C4.5511 20.8051 8.84196 20.4463 12.8739 21.5514H13C13.0419 21.5567 13.0842 21.5567 13.1261 21.5514C17.1556 20.4196 21.4557 20.7792 25.2434 22.5647C25.3197 22.6089 25.4063 22.6323 25.4945 22.6325C25.5827 22.6327 25.6694 22.6097 25.7459 22.5657C25.8225 22.5218 25.8862 22.4585 25.9308 22.382C25.9754 22.3056 25.9992 22.2188 26 22.1302V5.97424C26.0001 5.90575 25.9863 5.83795 25.9596 5.77495C25.9328 5.71195 25.8936 5.65505 25.8443 5.6077C25.7951 5.56035 25.7367 5.52352 25.6729 5.49944C25.6091 5.47536 25.541 5.46454 25.4729 5.46763ZM1.00883 21.3209V6.47959H2.21185V19.1653C2.21106 19.2386 2.22611 19.3112 2.25598 19.3781C2.28584 19.445 2.32981 19.5046 2.38484 19.5527C2.43988 19.6009 2.50466 19.6365 2.57473 19.6571C2.64479 19.6776 2.71847 19.6827 2.79067 19.6719C3.83413 19.5117 4.88771 19.4271 5.94325 19.4186C7.40327 19.393 8.85722 19.6135 10.2446 20.0708C7.11027 19.6897 3.93094 20.1201 1.00883 21.3209ZM5.93947 18.4079C5.02329 18.41 4.10813 18.4693 3.19924 18.5852V5.28144C4.17759 5.06232 5.17669 4.95021 6.17907 4.94708C7.34166 4.88993 8.50309 5.08133 9.58654 5.50861C10.67 5.93589 11.6508 6.58932 12.4641 7.42569L12.4842 20.0252C10.5055 18.8581 8.23017 18.2972 5.93821 18.4117L5.93947 18.4079ZM13.4931 7.42569C14.3092 6.59316 15.2904 5.94227 16.3732 5.51526C17.4559 5.08826 18.616 4.89468 19.7781 4.94708C20.7825 4.95025 21.7837 5.06235 22.7642 5.28144V18.589C21.8604 18.472 20.9503 18.4111 20.0391 18.4066C17.7477 18.2979 15.474 18.8584 13.4931 20.0202V7.42569ZM24.9685 21.3209C22.0416 20.1181 18.8568 19.6881 15.7175 20.0721C17.1115 19.6131 18.5724 19.3926 20.0391 19.4198C21.0997 19.4276 22.1583 19.5122 23.2068 19.6731C23.279 19.684 23.3527 19.6789 23.4228 19.6583C23.4928 19.6378 23.5576 19.6022 23.6126 19.554C23.6677 19.5058 23.7116 19.4463 23.7415 19.3794C23.7714 19.3125 23.7864 19.2398 23.7856 19.1665V6.47959H24.9886L24.9685 21.3209Z"
                                          fill="#111111" />
                                      </svg>
                                      Readings
                                    </div>
                                  </div>
                                </div>

                                <div class="subtitle-div">
                                  <div class="single-title"
                                    :class="courseDetail.Summary.TestCount == 0 ? 'noDataAvail' : ''">
                                    <div class="subtitle">
                                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M10.1908 8.22127H6.37272C6.2752 8.21539 6.1775 8.22952 6.08564 8.26279C5.99378 8.29606 5.9097 8.34776 5.83856 8.41474C5.76743 8.48171 5.71075 8.56253 5.67201 8.65222C5.63326 8.74191 5.61328 8.83858 5.61328 8.93627C5.61328 9.03397 5.63326 9.13064 5.67201 9.22033C5.71075 9.31002 5.76743 9.39082 5.83856 9.45779C5.9097 9.52477 5.99378 9.57649 6.08564 9.60976C6.1775 9.64303 6.2752 9.65716 6.37272 9.65128H10.1908C10.373 9.64029 10.5441 9.56017 10.6692 9.42729C10.7943 9.2944 10.864 9.11878 10.864 8.93627C10.864 8.75377 10.7943 8.57814 10.6692 8.44526C10.5441 8.31238 10.373 8.23226 10.1908 8.22127Z"
                                          fill="#111111" />
                                        <path
                                          d="M10.1908 12.0406H6.37272C6.2752 12.0347 6.1775 12.0489 6.08564 12.0821C5.99378 12.1154 5.9097 12.1671 5.83856 12.2341C5.76743 12.301 5.71075 12.3819 5.67201 12.4716C5.63326 12.5612 5.61328 12.6579 5.61328 12.7556C5.61328 12.8533 5.63326 12.95 5.67201 13.0397C5.71075 13.1294 5.76743 13.2102 5.83856 13.2771C5.9097 13.3441 5.99378 13.3958 6.08564 13.4291C6.1775 13.4624 6.2752 13.4765 6.37272 13.4706H10.1908C10.373 13.4596 10.5441 13.3795 10.6692 13.2466C10.7943 13.1137 10.864 12.9381 10.864 12.7556C10.864 12.5731 10.7943 12.3975 10.6692 12.2646C10.5441 12.1317 10.373 12.0516 10.1908 12.0406Z"
                                          fill="#111111" />
                                        <path
                                          d="M10.1908 15.8587H6.37272C6.2752 15.8528 6.1775 15.8669 6.08564 15.9002C5.99378 15.9335 5.9097 15.9852 5.83856 16.0522C5.76743 16.1192 5.71075 16.2 5.67201 16.2896C5.63326 16.3793 5.61328 16.476 5.61328 16.5737C5.61328 16.6714 5.63326 16.7681 5.67201 16.8578C5.71075 16.9475 5.76743 17.0283 5.83856 17.0952C5.9097 17.1622 5.99378 17.2139 6.08564 17.2472C6.1775 17.2805 6.2752 17.2946 6.37272 17.2887H10.1908C10.373 17.2777 10.5441 17.1976 10.6692 17.0647C10.7943 16.9319 10.864 16.7562 10.864 16.5737C10.864 16.3912 10.7943 16.2156 10.6692 16.0827C10.5441 15.9498 10.373 15.8697 10.1908 15.8587Z"
                                          fill="#111111" />
                                        <path
                                          d="M20.4545 14.4235V7.88585C20.4569 6.9476 20.0887 6.04636 19.4301 5.37815L16.5246 2.37515C16.1903 2.03575 15.7921 1.76598 15.353 1.58145C14.9139 1.39691 14.4425 1.30127 13.9662 1.30005L4.74916 1.30005C4.1798 1.30074 3.63394 1.52722 3.23134 1.92983C2.82874 2.33243 2.60225 2.87828 2.60156 3.44765V22.0168C2.60225 22.5862 2.82874 23.1321 3.23134 23.5347C3.63394 23.9373 4.1798 24.1638 4.74916 24.1644H15.8161C16.4651 24.7924 17.2543 25.2569 18.1184 25.5195C18.9825 25.7821 19.8967 25.8353 20.7854 25.6748C21.6741 25.5142 22.5119 25.1444 23.2294 24.596C23.947 24.0476 24.5237 23.3363 24.912 22.5209C25.3003 21.7055 25.4889 20.8094 25.4624 19.9067C25.4358 19.004 25.1948 18.1205 24.7593 17.3294C24.3238 16.5382 23.7062 15.8621 22.9577 15.3568C22.2091 14.8515 21.3511 14.5316 20.4545 14.4235ZM4.03156 22.0168V3.44765C4.03156 3.25767 4.10703 3.07548 4.24136 2.94115C4.3757 2.80682 4.55789 2.73135 4.74786 2.73135H13.9649C14.2495 2.73224 14.5312 2.78932 14.7938 2.8993C15.0564 3.00928 15.2946 3.17 15.495 3.37225L18.4018 6.37005C18.7977 6.77093 19.0192 7.31202 19.018 7.87545V14.43C18.1054 14.5465 17.2349 14.8828 16.4811 15.4102C15.7274 15.9376 15.1131 16.6402 14.691 17.4576C14.269 18.2749 14.0518 19.1826 14.0583 20.1025C14.0647 21.0224 14.2945 21.927 14.728 22.7383H4.74916C4.65455 22.7385 4.56084 22.7199 4.47344 22.6837C4.38604 22.6475 4.30669 22.5943 4.23997 22.5272C4.17325 22.4601 4.12048 22.3805 4.08471 22.2929C4.04894 22.2053 4.03088 22.1115 4.03156 22.0168ZM19.7382 24.31C18.8997 24.3018 18.0825 24.0457 17.3893 23.5739C16.6962 23.1021 16.1581 22.4358 15.8429 21.6588C15.5278 20.8818 15.4495 20.029 15.6181 19.2076C15.7867 18.3863 16.1946 17.6332 16.7904 17.0432C17.3861 16.4532 18.1432 16.0527 18.9661 15.8921C19.7891 15.7315 20.6411 15.818 21.415 16.1408C22.1889 16.4635 22.85 17.008 23.315 17.7057C23.78 18.4035 24.0281 19.2232 24.0282 20.0616C24.0275 20.6229 23.9158 21.1784 23.6994 21.6963C23.4831 22.2141 23.1664 22.6841 22.7676 23.079C22.3688 23.4739 21.8959 23.786 21.3759 23.9973C20.856 24.2085 20.2994 24.3149 19.7382 24.31Z"
                                          fill="#111111" />
                                        <path
                                          d="M21.3897 18.3639C21.3174 18.3037 21.2339 18.2583 21.1441 18.2304C21.0543 18.2025 20.9598 18.1925 20.8662 18.2011C20.7725 18.2097 20.6814 18.2366 20.5982 18.2804C20.5149 18.3241 20.4411 18.3839 20.3809 18.4562L19.1719 19.907L18.8976 19.3584C18.8573 19.2714 18.7999 19.1933 18.7289 19.1288C18.6579 19.0644 18.5746 19.0148 18.4841 18.9832C18.3936 18.9515 18.2976 18.9383 18.2019 18.9445C18.1062 18.9506 18.0127 18.9758 17.927 19.0188C17.8412 19.0617 17.7649 19.1214 17.7027 19.1943C17.6404 19.2673 17.5934 19.352 17.5645 19.4435C17.5356 19.5349 17.5254 19.6312 17.5344 19.7267C17.5435 19.8222 17.5715 19.9149 17.6171 19.9993L18.3802 21.5268C18.4335 21.633 18.5124 21.7242 18.6098 21.7922C18.7071 21.8603 18.8199 21.9031 18.9379 21.9168C18.9656 21.9184 18.9934 21.9184 19.0211 21.9168C19.1262 21.9164 19.2299 21.893 19.325 21.8481C19.42 21.8031 19.504 21.7378 19.571 21.6568L21.4807 19.3662C21.6004 19.2207 21.6579 19.0339 21.6408 18.8463C21.6238 18.6587 21.5336 18.4854 21.3897 18.3639Z"
                                          fill="#111111" />
                                        <path
                                          d="M14.0094 9.65128H14.7725C14.9547 9.64029 15.1258 9.56017 15.2509 9.42729C15.376 9.2944 15.4457 9.11878 15.4457 8.93627C15.4457 8.75377 15.376 8.57814 15.2509 8.44526C15.1258 8.31238 14.9547 8.23226 14.7725 8.22127H14.0094C13.9119 8.21539 13.8142 8.22952 13.7224 8.26279C13.6305 8.29606 13.5464 8.34776 13.4753 8.41474C13.4042 8.48171 13.3475 8.56253 13.3087 8.65222C13.27 8.74191 13.25 8.83858 13.25 8.93627C13.25 9.03397 13.27 9.13064 13.3087 9.22033C13.3475 9.31002 13.4042 9.39082 13.4753 9.45779C13.5464 9.52477 13.6305 9.57649 13.7224 9.60976C13.8142 9.64303 13.9119 9.65716 14.0094 9.65128Z"
                                          fill="#111111" />
                                        <path
                                          d="M15.4904 12.7568C15.4904 12.5668 15.415 12.3846 15.2807 12.2503C15.1463 12.116 14.9641 12.0405 14.7741 12.0405H14.011C13.8289 12.0515 13.6578 12.1316 13.5326 12.2645C13.4075 12.3974 13.3379 12.573 13.3379 12.7555C13.3379 12.938 13.4075 13.1137 13.5326 13.2465C13.6578 13.3794 13.8289 13.4595 14.011 13.4705H14.7741C14.9637 13.4705 15.1455 13.3954 15.2797 13.2617C15.414 13.1279 15.4898 12.9463 15.4904 12.7568Z"
                                          fill="#111111" />
                                      </svg>
                                      Quizzes
                                    </div>
                                  </div>
                                  <div class="single-title"
                                    :class="courseDetail.Summary.AssignmentCount == 0 ? 'noDataAvail' : ''">
                                    <div class="subtitle">
                                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M12.1871 23.2401C12.1871 23.4767 12.0932 23.7035 11.9259 23.8707C11.7587 24.038 11.5318 24.1319 11.2953 24.1319H6.16681C5.22105 24.1309 4.31431 23.7548 3.64556 23.086C2.9768 22.4172 2.60064 21.5105 2.59961 20.5647V4.86725C2.60064 3.92149 2.9768 3.01475 3.64556 2.346C4.31431 1.67724 5.22105 1.30108 6.16681 1.30005L17.1323 1.30005C18.0781 1.30108 18.9848 1.67724 19.6536 2.346C20.3223 3.01475 20.6985 3.92149 20.6995 4.86725V14.3208C20.6995 14.5574 20.6056 14.7842 20.4383 14.9514C20.2711 15.1187 20.0442 15.2126 19.8077 15.2126C19.5712 15.2126 19.3444 15.1187 19.1771 14.9514C19.0099 14.7842 18.9159 14.5574 18.9159 14.3208V4.86725C18.9152 4.39442 18.7271 3.94115 18.3927 3.60681C18.0584 3.27247 17.6051 3.08434 17.1323 3.08365H6.16681C5.69398 3.08434 5.24071 3.27247 4.90637 3.60681C4.57203 3.94115 4.3839 4.39442 4.38321 4.86725V20.5647C4.3839 21.0376 4.57203 21.4908 4.90637 21.8252C5.24071 22.1595 5.69398 22.3477 6.16681 22.3483H11.2953C11.5318 22.3483 11.7587 22.4423 11.9259 22.6095C12.0932 22.7768 12.1871 23.0036 12.1871 23.2401ZM22.695 15.8301C22.5028 15.6925 22.2637 15.6367 22.0304 15.6753C21.7971 15.7138 21.5887 15.8434 21.4509 16.0355L17.0543 22.1767C17.0094 22.2285 16.9544 22.2706 16.8928 22.3007C16.8312 22.3307 16.7642 22.348 16.6957 22.3515C16.6273 22.355 16.5588 22.3447 16.4944 22.3212C16.4301 22.2976 16.3711 22.2613 16.3211 22.2144L13.4754 19.4844C13.3909 19.4034 13.2913 19.3397 13.1821 19.2971C13.073 19.2545 12.9566 19.2339 12.8395 19.2363C12.7224 19.2387 12.607 19.2642 12.4997 19.3112C12.3924 19.3582 12.2955 19.4259 12.2144 19.5104C12.1333 19.595 12.0697 19.6946 12.0271 19.8037C11.9845 19.9128 11.9638 20.0292 11.9662 20.1463C11.9687 20.2634 11.9941 20.3789 12.0412 20.4862C12.0882 20.5934 12.1559 20.6904 12.2404 20.7714L15.0887 23.5014C15.5158 23.9067 16.082 24.1328 16.6708 24.1332C16.7211 24.1332 16.7713 24.1332 16.8216 24.1332C17.1396 24.1108 17.4494 24.0225 17.7314 23.8739C18.0134 23.7253 18.2614 23.5196 18.4596 23.27L18.4895 23.231L22.9095 17.0651C23.0471 16.8728 23.1026 16.6336 23.0638 16.4003C23.025 16.167 22.8952 15.9586 22.7028 15.821L22.695 15.8301ZM16.2405 6.65085H7.05341C6.81689 6.65085 6.59006 6.74481 6.42281 6.91205C6.25557 7.0793 6.16161 7.30613 6.16161 7.54265C6.16161 7.77917 6.25557 8.006 6.42281 8.17325C6.59006 8.34049 6.81689 8.43445 7.05341 8.43445H16.2392C16.4757 8.43445 16.7026 8.34049 16.8698 8.17325C17.0371 8.006 17.131 7.77917 17.131 7.54265C17.131 7.30613 17.0371 7.0793 16.8698 6.91205C16.7026 6.74481 16.4757 6.65085 16.2392 6.65085H16.2405ZM17.1323 11.1098C17.1323 10.8733 17.0384 10.6465 16.8711 10.4792C16.7039 10.312 16.477 10.218 16.2405 10.218H7.05341C6.81689 10.218 6.59006 10.312 6.42281 10.4792C6.25557 10.6465 6.16161 10.8733 6.16161 11.1098C6.16161 11.3464 6.25557 11.5732 6.42281 11.7404C6.59006 11.9077 6.81689 12.0016 7.05341 12.0016H16.2392C16.3564 12.0018 16.4725 11.9789 16.5809 11.9341C16.6892 11.8894 16.7877 11.8237 16.8706 11.7409C16.9536 11.6581 17.0194 11.5597 17.0643 11.4514C17.1092 11.3431 17.1323 11.2271 17.1323 11.1098ZM7.05341 13.78C6.81689 13.78 6.59006 13.874 6.42281 14.0413C6.25557 14.2085 6.16161 14.4353 6.16161 14.6718C6.16161 14.9084 6.25557 15.1352 6.42281 15.3024C6.59006 15.4697 6.81689 15.5636 7.05341 15.5636H12.633C12.8695 15.5636 13.0964 15.4697 13.2636 15.3024C13.4309 15.1352 13.5248 14.9084 13.5248 14.6718C13.5248 14.4353 13.4309 14.2085 13.2636 14.0413C13.0964 13.874 12.8695 13.78 12.633 13.78H7.05341Z"
                                          fill="#111111" stroke="white" stroke-width="0.325" />
                                      </svg>
                                      Assignments
                                    </div>
                                  </div>
                                </div>

                                <div class="subtitle-div">
                                  <div class="single-title">
                                    <div class="subtitle">
                                      <svg width="26" height="27" viewBox="0 0 26 27" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_2455_2627)">
                                          <path
                                            d="M23.1664 7.71899C22.8991 7.46112 22.5828 7.25941 22.2362 7.12578C21.8896 6.99215 21.5197 6.9293 21.1485 6.94094C17.9775 7.04618 15.397 7.73553 13.4737 8.99107C13.3258 9.08757 13.153 9.13895 12.9765 9.13895C12.7999 9.13895 12.6271 9.08757 12.4792 8.99107C10.5573 7.73599 7.97545 7.04664 4.80444 6.9414C4.43316 6.92909 4.0632 6.99164 3.71659 7.1253C3.36998 7.25897 3.05383 7.46103 2.78695 7.71945C2.52035 7.97559 2.30849 8.28315 2.16417 8.62353C2.01985 8.9639 1.94608 9.33001 1.94732 9.69972V21.6728C1.94291 22.3874 2.21808 23.0754 2.71406 23.5898C3.21004 24.1042 3.88751 24.4044 4.60177 24.4261C7.40513 24.518 9.73789 25.1384 11.5371 26.2749C11.9689 26.5452 12.468 26.6885 12.9774 26.6885C13.4868 26.6885 13.9859 26.5452 14.4177 26.2749C16.2159 25.1384 18.5492 24.5166 21.3521 24.4261C22.0663 24.4044 22.7438 24.1042 23.2398 23.5898C23.7358 23.0754 24.0109 22.3874 24.0065 21.6728V9.69972C24.0078 9.3299 23.9339 8.96368 23.7895 8.62322C23.6451 8.28276 23.4332 7.97515 23.1664 7.71899ZM4.66106 22.5883C4.42557 22.5771 4.20339 22.4758 4.04044 22.3054C3.8775 22.135 3.78626 21.9086 3.78558 21.6728V9.69972C3.78531 9.57649 3.81001 9.45448 3.8582 9.34105C3.90638 9.22763 3.97704 9.12514 4.06592 9.03978C4.23907 8.87123 4.47135 8.77719 4.71299 8.77783H4.74424C7.57333 8.86974 9.83762 9.4612 11.4741 10.5292C11.6568 10.6461 11.8527 10.7407 12.0578 10.811V24.455C9.78064 23.2407 7.24173 22.5999 4.66106 22.5883ZM22.1682 21.6728C22.1676 21.9082 22.0767 22.1343 21.9142 22.3047C21.7518 22.475 21.5302 22.5765 21.2951 22.5883C18.7135 22.5994 16.1737 23.2403 13.896 24.4555V10.8114C14.1011 10.7409 14.297 10.6464 14.4797 10.5297C16.1162 9.46166 18.3805 8.87204 21.2091 8.77829C21.3342 8.77243 21.4592 8.79265 21.576 8.83767C21.6929 8.88268 21.7991 8.95151 21.8879 9.03978C21.9768 9.12514 22.0475 9.22763 22.0956 9.34105C22.1438 9.45448 22.1685 9.57649 22.1682 9.69972V21.6728Z"
                                            fill="#111111" stroke="white" stroke-width="0.3" />
                                          <path
                                            d="M16.4974 5.95498C16.2275 6.25637 15.7636 6.28213 15.4622 6.01226C14.069 4.76513 11.9686 4.76513 10.5754 6.01226C10.274 6.28213 9.81013 6.25637 9.54021 5.95498C9.27102 5.65432 9.29536 5.18969 9.59749 4.91976C11.5476 3.17297 14.49 3.17297 16.4401 4.91976C16.7423 5.18983 16.767 5.65456 16.4974 5.95498Z"
                                            fill="#111111" stroke="white" stroke-width="0.3" />
                                          <path
                                            d="M17.7787 2.34496L17.7788 2.34498C18.0744 2.56676 18.1325 2.9862 17.9118 3.28052C17.69 3.57543 17.2711 3.63481 16.9762 3.41362C14.6228 1.64592 11.3351 1.64592 8.98174 3.41362C8.68684 3.6348 8.26794 3.57544 8.04607 3.28051L7.99413 3.31959L8.04612 3.28059C7.82493 2.98567 7.88508 2.56538 8.17914 2.34499L8.17918 2.34496C11.0054 0.223175 14.9525 0.223175 17.7787 2.34496Z"
                                            fill="#111111" stroke="white" stroke-width="0.13" />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_2455_2627">
                                            <rect width="26" height="26" fill="white"
                                              transform="translate(0 0.688477)" />
                                          </clipPath>
                                        </defs>
                                      </svg>

                                      Live Lectures
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>

                      <!-- <div
                        v-if="courseDetail && courseDetail.Packages.length > 0"
                        class="all-features-wrap"
                        id="all-features-wrap"
                        :class="{ sticky: isSticky }"
                      >
                        <div class="empty-features-div"></div>
                        <div
                          class="feature-details-wrap col-12 p-0"
                          id="feature-details-wrap"
                        >
                          <div class="col-12 feature-col p-0">
                            <div class="feature-details">
                              <div class="features-heading-wrap">
                                <h5>Features</h5>
                              </div>
                              <div class="plan-features-wrap">
                                <div
                                  v-for="packages in courseDetail.Packages"
                                  :key="packages.SOSPaymentPackageId"
                                  class="plan-feature-name d-none"
                                >
                                  <span>{{ packages.Title }}</span>
                                  <button
                                    @click="
                                      showPaymentPlansPopup(
                                        packages,
                                        selectedPaymentOption
                                      )
                                    "
                                    class="btn secondary-btn"
                                  >
                                    Add To Cart
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-for="(detail, index) in courseDetail.Packages[0].Features"
                            :key="detail.index"
                            class="col-12 feature-col p-0"
                          >
                            <div class="feature-name-details">
                              <p>
                                <strong>{{ detail.Name }} :</strong
                                >{{ detail.Description }}
                              </p>
                            </div>

                            <div class="feature-details">
                              <div class="features-heading-wrap">
                                <h5 class="">&nbsp;</h5>
                              </div>
                              <div class="plan-features-wrap text-center d-none">
                                <div
                                  v-for="packages in courseDetail.Packages"
                                  :key="packages.SOSPaymentPackageId"
                                  class="plan-feature-name"
                                >
                                  <div
                                    v-if="
                                      packages.Features &&
                                      packages.Features[index] &&
                                      packages.Features[index].IsFeatureAllowed
                                    "
                                  >
                                    <img
                                      src="/assets/images/checked.svg"
                                      width="24"
                                      height="24"
                                      alt=""
                                    />
                                  </div>
                                  <div v-else class="not-available">
                                    <img
                                      src="/assets/images/checked.svg"
                                      width="24"
                                      height="24"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>

                    <div class="cart-btns p-0" v-if="courseDetail && courseDetail.IsFree">
                      <button @click="FreeCourse(courseDetail)" class="btn secondary-btn purple-btn">Enroll</button>
                    </div>
                  </div>

                  <!-- <div
                    :class="
                      courseDetail && courseDetail.Packages.length === 0
                        ? 'col-12 pb-5'
                        : 'col-12'
                    "
                  >
                    <div class="course-accordion-wrapper">
                      <div class="accordion" role="tablist">
                        <b-card no-body class="mb-3 mb-xl-4">
                          <b-card-header header-tag="header" class="p-0" role="tab">
                            <button
                              role="button"
                              block
                              v-b-toggle.accordion-2
                              variant="info"
                            >
                              Program Details
                            </button>
                          </b-card-header>
                          <b-collapse
                            id="accordion-2"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body>
                              <b-card-text
                                v-if="courseDetail && courseDetail.ProgramDescription"
                              >
                                <div
                                  v-html="courseDetail && courseDetail.ProgramDescription"
                                ></div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>

                        <b-card no-body>
                          <b-card-header header-tag="header" class="p-0" role="tab">
                            <button block v-b-toggle.accordion-3 variant="info">
                              Course Details
                            </button>
                          </b-card-header>
                          <b-collapse
                            id="accordion-3"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body>
                              <b-card-text> </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- <loader id="checkoutLoaderId"></loader> -->

        <!-- <section class="details-section" :style="{ minHeight: boxHeight }">
          <div class="container">
            <div class="row detail-sec-row justify-content-center"></div>
          </div>
          <div class="container multiPlansCard d-none" id="paymentPlans">
            <span id="targetedPlan"></span>
            <div class="d-none d-lg-block"
              v-if="courseDetail && courseDetail.Packages && courseDetail.Packages.length === 2">
              <paymentplanmarkup @choosePlan="showPaymentPlansPopup" @trial="AddToTrial(true)" />
            </div>
            <div class="d-none d-lg-block"
              v-else-if="courseDetail && courseDetail.Packages && courseDetail.Packages.length > 2">
              <multiplePackages @choosePlan="showPaymentPlansPopup" @trial="AddToTrial(true)" />
            </div>
            Mobile View Start here

            <div id="mobileAccordion" class="d-block d-lg-none"
              v-if="courseDetail && courseDetail.Packages && courseDetail.Packages.length > 1">
              <twoPaymentPlans @choosePlan="showPaymentPlansPopup" @trial="AddToTrial(true)" />
            </div>
            Mobile View end here
          </div> 
        </section> -->
        <!-- </template>
</skeleton-loader> -->
        <cartConfirmationModal />
        <b-modal centered text id="paymentPlanModal" title="" hide-footer no-close-on-backdrop>
          <div class="mtb30 cart-popup">
            <div class="modal-head modal-head-success payment-model">
              <div v-if="selectedPackage">
                <h3>{{ selectedPackage.Title }} : <span>Payment Plan</span></h3>
                <div class="planstrip" v-for="element in selectedPackage.PaymentPlans" :key="element.SOSPaymentPlanId">
                  <label class="radioWrap">
                    <input type="radio" :id="element.SOSPaymentPlanId" v-model="selected"
                      :value="element.SOSPaymentPlanId" @change="changePaymentPlan(null, element)" />
                    <span class="checkmark"></span>
                  </label>
                  <label class="plandetail" :for="element.SOSPaymentPlanId">
                    <div class="planHeading">{{ element.Title }}</div>
                    <div class="planamount">
                      <span class="font-weight-bold">{{ element.Price.Format }}</span>
                      <span class="strikethrough">{{ element.PriceStrikethrough.Format }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="button-bar-confirm">
              <button @click="checkIfPlanAlreadyExist()" class="btn secondary-btn purple-btn"
                :disabled="!selected">Choose a
                plan</button>
            </div>
          </div>
        </b-modal>
        <b-modal v-if="this.courseDetail.VideoLink" size="lg" centered id="videoModal" title="" hide-footer hide-header
          content-class="p-0">
          <div class="video-container">
            <iframe :src="youtubeEmbedURL" class="responsive-iframe" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
        </b-modal>
      </section>

      <!-- <appFooter /> -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { CartModel } from "../../models/app/cartModel";
import { appConstants } from "../../common/constants";
import { courseDetail as courseDetailStoreKeys, course as courseStoreKeys, checkout as checkoutStoreKeys, cart as cartStoreKeys } from "../../store/keys";
import cartConfirmationModal from "./cartConfirmationModal.vue";
import pageHeader from "../../components/pageHeader.vue";
// import footer from "../../layout/landing/appFooter.vue";
import coursePackage from "../../components/packages.vue";
import paymentplanmarkup from "../../components/paymentplanmarkup.vue";
import multiplePackages from "../../components/multiplePackages.vue";
import twoPaymentPlans from "../../components/twoPaymentPlans.vue";
import singlePaymentPlan from "../../components/singlePaymentPlan.vue";
export default {
  components: {
    cartConfirmationModal,
    pageHeader,
    // appFooter: footer,
    coursePackage,
    paymentplanmarkup,
    multiplePackages,
    twoPaymentPlans,
    singlePaymentPlan,
  },
  metaInfo() {
    return {
      title: `${this.title} | KIPS ONLINE SCHOOL`,
      titleTemplate: "",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
      meta: [
        {
          name: "description",
          content: this.courseDetail && this.courseDetail.ShortDescription,
        },
        {
          property: "og:title",
          content: this.courseDetail && this.courseDetail.DisplayName,
        },
        {
          property: "og:description",
          content: this.courseDetail && this.courseDetail.ShortDescription,
        },
        {
          property: "og:image",
          content: this.courseDetail && this.courseDetail.CourseImage,
        },
      ],
    };
  },
  // props: {
  //   sosId: Number,
  // },
  watch: {
    $route(to, from) {
      if (process.env.VUE_ENV === "client") {
        this.getCourseDetail();
      }
    },
  },
  data() {
    return {
      // caption: routeParams.board.replace("-", " ") - routeParams.group,
      isSticky: false,
      isActive: false,
      title: "",
      // isTrial: false,
      selectedPaymentOption: appConstants.enums.PaymentOption.PaymentPlan,
      routeParams: null,
      isBtnDisable: false,
      isServer: process.env.VUE_ENV,
      loading: true,
      // selectedPaymentPlan: {
      //   SOSPaymentPlanId: 0,
      // },
      defaultSelectedPackage: {
        SOSPackageId: 0,
        SOSPackageTitle: "",
        SOSPaymentPlan: {
          id: 0,
          title: "",
          price: 0,
          priceDisplay: "",
          priceStrikethrough: 0,
          priceStrikethroughDisplay: "",
          billingPeriod: {
            frequency: "",
            name: "",
          },
        },
      },
      selected: "",
      selectedPackage: null,
    };
  },
  serverPrefetch() {
    this.reset_CourseDetail();
    return this.getCourseDetail();
  },
  created() {
    this.routeParams = this.$route.params;
  },
  beforeDestroy() {
    this.reset_CourseDetail();
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener("scroll", this.handleScroll);
    this.getCourseDetail().then(() => {
      this.loading = false;
    });
    this.scrollToSelectedNote();
  },
  computed: {
    ...mapGetters(courseDetailStoreKeys.namespace, courseDetailStoreKeys.getters),
    ...mapGetters(courseStoreKeys.namespace, courseStoreKeys.getters),
    ...mapGetters(cartStoreKeys.namespace, cartStoreKeys.getters),
    sliderArrow() {
      return this.isActive ? "fas fa-angle-down" : "fas fa-angle-up";
    },
    youtubeEmbedURL() {
      return "https://www.youtube.com/embed/" + this.courseDetail.VideoLink.split("v=")[1].split("&")[0];
    },
    paymentPlans() {
      return this.courseDetail.Packages.find((el) => {
        return el.SOSPaymentPackageId === this.getSelectedSosPaymentPackageId;
      });
    },
  },
  methods: {
    boxHeight() {
      if (this.$refs.stickyBox) {
        return this.$refs.stickyBox.clientHeight + "px";
      }
    },
    handleScroll() {
      const featureWrap = document.getElementById("all-features-wrap");
      const topThreshold = 70;
      if (featureWrap) {
        const isSticky = featureWrap.getBoundingClientRect().top <= topThreshold;
        // Update the sticky state
        this.isSticky = isSticky;
      }
    },
    ...mapActions(courseDetailStoreKeys.namespace, courseDetailStoreKeys.actions),
    ...mapActions(courseStoreKeys.namespace, courseStoreKeys.actions),
    ...mapActions(cartStoreKeys.namespace, cartStoreKeys.actions),
    ...mapActions(checkoutStoreKeys.namespace, checkoutStoreKeys.actions),
    showVideoPopup() {
      this.$bvModal.show("videoModal");
    },
    // getYouTubeEmbedURL() {
    //   if (!this.courseDetail?.VideoLink) return '';
    //   const videoID = this.courseDetail.VideoLink.split('v=')[1]?.split('&')[0];
    //   return `https://www.youtube.com/embed/${videoID}`;
    // },
    showPaymentPlansPopup(paymentPackage, paymentOption) {
      this.selectedPaymentOption = paymentOption;
      this.selectedPackage = paymentPackage;
      if (paymentPackage) {
        if (this.selectedPackage.PaymentPlans.length > 1) {
          this.$bvModal.show("paymentPlanModal");
        } else {
          this.changePaymentPlan(this.selectedPackage.PaymentPlans[0].SOSPaymentPlanId, this.selectedPackage.PaymentPlans[0]);
          this.checkIfPlanAlreadyExist();
        }
      } else {
        this.$bvModal.show("paymentPlanModal");
      }
    },

    changePaymentPlan(id, element) {
      this.defaultSelectedPackage = {
        SOSPackageId: this.selectedPackage.SOSPaymentPackageId,
        SOSPackageTitle: this.selectedPackage.Title,
        SOSPaymentPlan: {
          id: id || this.selected,
          title: element.Title,
          price: element.Price.Value,
          priceDisplay: element.Price.Format,
          priceStrikethrough: element.PriceStrikethrough.Value,
          priceStrikethroughDisplay: element.PriceStrikethrough.Format,
          billingPeriod: {
            frequency: element.BillingPeriod.Frequency,
            name: element.BillingPeriod.Period.Name,
          },
        },
      };
    },
    checkIfPlanAlreadyExist() {
      this.$bvModal.hide("paymentPlanModal");
      if (this.isPaymentPlanExist(this.$decryptedRouteParams.sosId)) {
        this.removeFromCart();
      } else {
        this.addToCart();
      }
    },
    removeFromCart() {
      this.remove_FromCart({
        data: this.$decryptedRouteParams.sosId,
        config: {
          loader: {
            show: false,
          },
        },
      })
        .then((response) => {
          // this.$bvModal.hide(`${this.selected}confirmCartModal1`);
          // this.checkout_cart();
          this.addToCart();
        })
        .catch((ex) => {
          // this.$alertError(ex.message);
          console.log(ex)
        });
    },
    selectPaymentPlan(object) {
      this.defaultSelectedPackage = object;
    },
    addToCart() {
      // if (this.selectedPaymentOption === appConstants.enums.PaymentOption.PaymentPlan) {
      //   this.$bvModal.show("confirmCartModal");
      // }
      let cartModel = new CartModel();
      cartModel.ProgramCategoryId = this.courseDetail.ProgramCategoryId;
      cartModel.BoardId = this.courseDetail.BoardId;
      cartModel.CourseGroupId = this.courseDetail.CourseGroupId;
      cartModel.SOSId = this.courseDetail.SOSId;
      cartModel.CourseName = this.courseDetail.DisplayName;
      cartModel.CourseGroupName = this.courseDetail.CourseGroupName;
      cartModel.BoardName = this.courseDetail.BoardName;
      cartModel.CourseImage = this.courseDetail.CourseImage;
      cartModel.PaymentOption = this.selectedPaymentOption;
      cartModel.SOSPaymentPlanId = this.defaultSelectedPackage.SOSPaymentPlan.id;
      cartModel.SOSPaymentPackageId = this.defaultSelectedPackage.SOSPackageId;
      cartModel.SOSPaymentPackageTitle = this.defaultSelectedPackage.SOSPackageTitle;
      // cartModel.SOSPaymentPlanId = this.selectedPlan.PaymentPlans.find((el) => el.IsSelectedPlan === true).SOSPaymentPlanId;
      // cartModel.SOSPaymentPackageId = this.selectedPlan.SOSPaymentPackageId;
      cartModel.InstituteId = this.courseDetail.InstituteId;

      if (this.selectedPaymentOption === appConstants.enums.PaymentOption.PaymentPlan) {
        cartModel.Amount = this.defaultSelectedPackage.SOSPaymentPlan.price;
        cartModel.AmountDisplay = this.defaultSelectedPackage.SOSPaymentPlan.priceDisplay;
        cartModel.Title = this.defaultSelectedPackage.SOSPaymentPlan.title;
        cartModel.AmountStrikethrough = this.defaultSelectedPackage.SOSPaymentPlan.priceStrikethrough || this.defaultSelectedPackage.SOSPaymentPlan.price;
        cartModel.AmountStrikethroughDisplay = this.defaultSelectedPackage.SOSPaymentPlan.priceStrikethroughDisplay;
        cartModel.BillingPeriodFrequency = this.defaultSelectedPackage.SOSPaymentPlan.billingPeriod.frequency;
        cartModel.BillingPeriodName = this.defaultSelectedPackage.SOSPaymentPlan.billingPeriod.name;
      } else if (this.selectedPaymentOption === appConstants.enums.PaymentOption.Trial) {
        cartModel.Amount = 0.0;
        cartModel.AmountDisplay = this.toCurrency(0); //"Rs 0.00";
        cartModel.AmountStrikethroughDisplay = this.toCurrency(0); //"Rs 0.00";
      }

      this.add_ToCart({
        data: cartModel,
        config: {
          loader: {
            show: true,
          },
        },
      })
        .then((response) => {
          // if (this.selectedPaymentOption === appConstants.enums.PaymentOption.Trial) {
          //   }
          this.checkoutTrial();
          //this.reset_SelectedCourseInfo();
        })
        .catch((ex) => {
          this.isBtnDisable = false;
          // this.$alertError(ex);
          console.log(ex)
        });
    },
    showBottomSlider() {
      this.isActive = !this.isActive;
    },
    // checkoutTrial() {
    //   this.checkout_cart().then((response) => {
    //     // this.$router.push({ name: "signUp" });
    //      window.location.href = `${process.env.VUE_APP_PORTAL_URL}/invoice/checkOut`;
    //   });
    // },
    checkoutTrial() {
      this.check_Out().then(() => {
        this.isBtnDisable = false;
      });
    },
    AddToTrial(obj) {
      this.isBtnDisable = true;
      this.isTrial = isTrial;
      this.selectedPaymentOption = appConstants.enums.PaymentOption.Trial;
      this.showPaymentPlansPopup(obj);
    },
    goToCart() {
      this.$router.push({ name: "cart" }).catch(() => { });
    },
    // handleScroll() {
    //   if (document.querySelector(".sticky-side-box")) {
    //     let topLimit = document.querySelector(".sticky-side-box").offsetTop;
    //     if (window.pageYOffset - 80 >= topLimit && window.innerWidth > 1199) {
    //       document.querySelector(".sticky-side-box").classList.add("make-it-sticky");
    //     } else if (window.pageYOffset <= 0) {
    //       document.querySelector(".sticky-side-box").classList.remove("make-it-sticky");
    //     }
    //   }

    //   let element = document.querySelector(".details-info");
    //   if (window.scrollY > element.offsetHeight + element.offsetTop - 300) {
    //     document.querySelector(".sticky-side-box").classList.remove("make-it-sticky");
    //     document.querySelector(".course-details-page").classList.add("position-relative");
    //   } else {
    //     document.querySelector(".course-details-page").classList.remove("position-relative");
    //   }
    // },
    setSelectedPaymentPlan(plan) {
      // if (
      //   this.selectedPaymentOption ===
      //   appConstants.enums.PaymentOption.PaymentPlan
      // ) {

      this.update_SelectedPlan({
        data: {
          selectedSOSPaymentPlanId: plan.SOSPaymentPlanId,
        },
      }).catch((ex) => {
        //this.$alertError(ex.message);
        console.log(ex)
      });
      //}
    },
    getCourseDetail() {
      return this.get_CourseDetail({
        data: {
          SOSId: this.$decryptedRouteParams.sosId,
          CourseGroupId: this.$decryptedRouteParams.courseGroupId,
        },
        config: {
          loader: {
            show: true,
            id: "courseDetailLoader",
          },
        },
      })
        .then((response) => {
          this.title = this.courseDetail.DisplayName;
          let SosObj = this.selectedSOS(this.courseDetail.SOSId);
          if (SosObj !== undefined) {
            // this.setSelectedPaymentPlan(SosObj);
            this.defaultSelectedPackage.SOSPackageId = SosObj.SOSPaymentPackageId;
            this.defaultSelectedPackage.SOSPackageTitle = SosObj.SOSPaymentPackageTitle;
            this.defaultSelectedPackage.SOSPaymentPlan = {
              id: SosObj.SOSPaymentPlanId,
              title: SosObj.Title,
              price: SosObj.Amount,
              priceDisplay: SosObj.AmountDisplay,
              priceStrikethrough: SosObj.AmountStrikethrough,
              priceStrikethroughDisplay: SosObj.AmountStrikethroughDisplay,
            };
            this.selected = SosObj.SOSPaymentPlanId;
          } else {
            let defaultPackage = this.courseDetail.Packages.filter((el) => {
              return el.PaymentPlans.filter((plan) => {
                return plan.IsSelectedPlan === true;
              });
            })[0];
            let defaultPaymentPlan = defaultPackage.PaymentPlans.find((el) => el.IsSelectedPlan == true);
            this.defaultSelectedPackage.SOSPackageId = defaultPackage.SOSPaymentPackageId;
            this.defaultSelectedPackage.SOSPackageTitle = defaultPackage.Title;
            this.defaultSelectedPackage.SOSPaymentPlan.id = defaultPaymentPlan.SOSPaymentPlanId;
            this.defaultSelectedPackage.SOSPaymentPlan.title = defaultPaymentPlan.Title;
            this.defaultSelectedPackage.SOSPaymentPlan.price = defaultPaymentPlan.Price.Value;
            this.defaultSelectedPackage.SOSPaymentPlan.priceDisplay = defaultPaymentPlan.Price.Format;
            this.defaultSelectedPackage.SOSPaymentPlan.priceStrikethrough = defaultPaymentPlan.PriceStrikethrough.Value;
            this.defaultSelectedPackage.SOSPaymentPlan.priceStrikethroughDisplay = defaultPaymentPlan.PriceStrikethrough.Format;
          }
          // else {
          //   let defaultPackage = this.courseDetail.Packages.filter((el) => {
          //     return el.PaymentPlans.filter((plan) => {
          //       return plan.IsSelectedPlan === true;
          //     });
          //   })[0];
          //   let defaultPaymentPlan = defaultPackage.PaymentPlans.find((el) => el.IsSelectedPlan == true);
          //   this.defaultSelectedPackage.SOSPackageId = defaultPackage.SOSPaymentPackageId;
          //   this.defaultSelectedPackage.SOSPackageTitle = defaultPackage.Title;
          //   this.defaultSelectedPackage.SOSPaymentPlan.id = defaultPaymentPlan.SOSPaymentPlanId;
          //   this.defaultSelectedPackage.SOSPaymentPlan.title = defaultPaymentPlan.Title;
          //   this.defaultSelectedPackage.SOSPaymentPlan.price = defaultPaymentPlan.Price.Value;
          //   this.defaultSelectedPackage.SOSPaymentPlan.priceDisplay = defaultPaymentPlan.Price.Format;
          //   this.defaultSelectedPackage.SOSPaymentPlan.priceStrikethrough = defaultPaymentPlan.PriceStrikethrough.Value;
          //   this.defaultSelectedPackage.SOSPaymentPlan.priceStrikethroughDisplay = defaultPaymentPlan.PriceStrikethrough.Format;
          // }
        })
        .catch((ex) => {
          if (ex.status == 404) {
            this.$router.push({ name: "landingPageNotFound" }).catch(() => { });
          }
          // this.$alertError(ex.message);
        });
    },
    FreeCourse(model) {
      this.isBtnDisable = true;
      this.selectedPaymentOption = appConstants.enums.PaymentOption.Free;
      let cartModel = new CartModel();
      cartModel.ProgramCategoryId = model.ProgramCategoryId;
      cartModel.CourseGroupId = model.CourseGroupId;
      cartModel.BoardId = model.BoardId;
      cartModel.InstituteId = model.InstituteId;
      cartModel.CourseGroupId = model.CourseGroupId;
      cartModel.SOSId = model.SOSId;
      cartModel.CourseName = model.SOSName;
      cartModel.PaymentOption = this.selectedPaymentOption;
      cartModel.SOSPaymentPlanId = null;
      this.reset_Cart();
      this.add_ToCart({
        data: cartModel,
        config: {
          loader: {
            show: true,
          },
        },
      })
        .then((response) => {
          if (model.IsSpecialActivity) {
            this.$router.push({ name: "registration" });
          } else {
            this.check_Out();
          }
          //this.reset_SelectedCourseInfo();
        })
        .catch((ex) => {
          this.isBtnDisable = false;
          // this.$alertError(ex);
          console.log(ex)
        });
    },
    scrolltoFeature() {
      console.log("clicked");
      setTimeout(() => {
        let element = document.querySelectorAll(".feature-details-wrap");
        if (element && element[0]) {
          element[0].scrollIntoView({
            alignToTop: false,
            behavior: "smooth",
            // block: "center",
          });
        }
      }, 100);
    },
    scrollToSelectedNote() {
      setTimeout(() => {
        let element = document.querySelectorAll(".highlight");
        if (element && element[0]) {
          element[0].scrollIntoView({
            alignToTop: false,
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    },
    scrollToPaymentPlans() {
      let element = document.querySelectorAll("#targetedPlan");
      if (element && element[0]) {
        element[0].scrollIntoView({
          alignToTop: true,
          behavior: "smooth",
          block: "start",
        });
      }
    },
  },
};
</script>
<style scoped>
.red {
  background-color: red;
}

.no-cursor {
  cursor: pointer;
  pointer-events: none;
}

@media (min-width: 1200px) {
  .position-relative {
    position: relative;
  }

  .position-relative .sticky-side-box {
    position: absolute;
    bottom: 70px;
    top: auto;
  }
}

.no-course-image {
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  color: rgba(156, 163, 175, 1);
  font-size: 6rem;
  line-height: 1;
  z-index: 0;
  top: 5rem;
  position: absolute;
}

::v-deep #videoModal .modal-content {
  background-color: black;
}

::v-deep #videoModal .modal-body {
  padding: 0 !important;
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* Add media query for larger screens */
@media (min-width: 992px) {
  ::v-deep #videoModal .modal-content {
    background-color: black;
  }

  .video-container {
    width: 152%;
    height: 80vh;
    /* This will take 80% of viewport height */
  }

  .responsive-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
